import { OrganizationTypes, APITypes } from '../primary-record-types';

export const clientRecordStatusTypeGuard = {
    notInvited: (
        record:
            | OrganizationTypes.OrganizationClientRecord
            | APITypes.organizationService.OrganizationClientRecordDetails,
    ): record is OrganizationTypes.OrganizationClientRecordForStatus<'not-invited'> => record.status === 'not-invited',
    archived: (
        record:
            | OrganizationTypes.OrganizationClientRecord
            | APITypes.organizationService.OrganizationClientRecordDetails,
    ): record is OrganizationTypes.OrganizationClientRecordForStatus<'archived'> => record.status === 'archived',
    invited: (
        record:
            | OrganizationTypes.OrganizationClientRecord
            | APITypes.organizationService.OrganizationClientRecordDetails,
    ): record is OrganizationTypes.OrganizationClientRecordForStatus<'invited'> => record.status === 'invited',
    invitationRejected: (
        record:
            | OrganizationTypes.OrganizationClientRecord
            | APITypes.organizationService.OrganizationClientRecordDetails,
    ): record is OrganizationTypes.OrganizationClientRecordForStatus<'invitation-rejected'> =>
        record.status === 'invitation-rejected',
    active: (
        record:
            | OrganizationTypes.OrganizationClientRecord
            | APITypes.organizationService.OrganizationClientRecordDetails,
    ): record is OrganizationTypes.OrganizationClientRecordForStatus<'active'> => record.status === 'active',
    inactive: (
        record:
            | OrganizationTypes.OrganizationClientRecord
            | APITypes.organizationService.OrganizationClientRecordDetails,
    ): record is OrganizationTypes.OrganizationClientRecordForStatus<'inactive'> => record.status === 'inactive',
};

export const clientRecordDetailsToClientRecord = (
    clientRecord: APITypes.organizationService.OrganizationClientRecordDetails,
): OrganizationTypes.OrganizationClientRecord => {
    return clientRecord as OrganizationTypes.OrganizationClientRecord;
};
